import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SapAccountCompanyCodeService } from '../proxy/controlling/controllers';
import { ListService } from '@abp/ng.core';
import {
  CardComponent,
  CardBodyComponent,
  ConfirmationService,
} from '@abp/ng.theme.shared';
import {
  SapAccountCompanyCodeCreateDto,
  SapAccountCompanyCodeDto,
  SapAccountCompanyCodeExcelDownloadDto,
  SapAccountCompanyCodeUpdateDto,
} from '../proxy/controlling/dtos/sap-account-company-code';
import { SAPACCOUNTCOMPANYCODE_CONFIG, SAPACCOUNTCOMPANYCODE_FIELDS } from './sap-account-company-code.config';
import { BaseHierarchicalCrudComponent, CrudPage, GenericForm } from '@zendra/shared';

@Component({
  selector: 'app-sap-account-company-code',
  imports: [
    CommonModule,
    CardComponent,
    CardBodyComponent,
    CrudPage,
    GenericForm,
  ],
  providers: [ListService, SapAccountCompanyCodeService, ConfirmationService],
  templateUrl: './sap-account-company-code.html',
  styleUrl: './sap-account-company-code.scss',
})
export class SapAccountCompanyCode extends BaseHierarchicalCrudComponent<
  SapAccountCompanyCodeDto,
  SapAccountCompanyCodeCreateDto,
  SapAccountCompanyCodeUpdateDto,
  SapAccountCompanyCodeExcelDownloadDto
> {
  service = inject(SapAccountCompanyCodeService);
  config = SAPACCOUNTCOMPANYCODE_CONFIG;
  fields = SAPACCOUNTCOMPANYCODE_FIELDS;

  protected prepareUpdateDto(data: any, selected: SapAccountCompanyCodeDto): SapAccountCompanyCodeUpdateDto {
    return {
      ...data,
      concurrencyStamp: selected.concurrencyStamp,
    };
  }

  protected getEntityName(): string {
    return 'SapAccountCompanyCode';
  }
}
